import React from 'react';
import { Col, Modal, notification, Row, Form, Card, Input } from 'antd';
import FormInput from 'components/FormInput';
import ParListByParcodeSelect from 'pages/Configuration/Components/ParListByParcodeSelect';
import { createParList } from 'services/parametersService';

type AddParListValueModalProps = {
  onCancel: () => void;
  visible: boolean;
  title: React.ReactNode | string;
  onSuccess?: () => void;
  iscreate?: boolean;
  showAsModal?: boolean;
  refetched: boolean;
  setrefetched: any;
  ParcodeParent: string;
  parcode: string;
  entity?: string;
};

const AddParListValueModal = (props: AddParListValueModalProps) => {
  const {
    onCancel,
    visible,
    title,
    ParcodeParent,
    parcode,
    entity,
    setrefetched,
  } = props;

  const [form] = Form.useForm();
  const submit = () => {
    const currentValue = form.getFieldsValue();
    const body = {
      ...currentValue,
      parcode: parcode,
    };
    createParList({ parListRequest: body }).then((response) => {
      if (response.code === '200') {
        notification.success({
          message: `${currentValue.parvalue} is created`,
        });
        setrefetched();
        onCancel();
      } else {
        notification.error({
          message: response.message,
          description: response.description,
        });
      }
    });
  };

  return (
    (<Modal
      open={visible}
      destroyOnClose
      width={600}
      title={title}
      onOk={submit}
      onCancel={onCancel}
    >
      <Card>
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col xs={12}>
              <FormInput name="parvalue" rules={[{ required: true }]} />
            </Col>
            <Col xs={12}>
              <FormInput name="parlistlabel" rules={[{ required: true }]} />
            </Col>
            <Col xs={12}>
              <FormInput name="parlistdescription" />
            </Col>
            <Col xs={12}>
              {entity &&
              entity !== 'ASSET' &&
              entity !== 'CATALOG' &&
              entity !== 'FVCONTEXT' &&
              entity !== 'FINASSET' &&
              entity !== 'THIRDPARTY' ? (
                <FormInput name="parvalueparent">
                  <Input />
                </FormInput>
              ) : (
                <FormInput name="parvalueparent">
                  <ParListByParcodeSelect parcode={ParcodeParent ?? ''} />
                </FormInput>
              )}
            </Col>
          </Row>
        </Form>
      </Card>
    </Modal>)
  );
};

export default AddParListValueModal;
